import { Component, EventEmitter, OnInit, ViewChild, } from '@angular/core';
import { MaterializeAction } from "angular2-materialize";
import { FormGroup } from '@angular/forms';
import { ModalPromptService, PromptOptions } from './modal-prompt.service';
import { Subject } from 'rxjs/Subject';

type ActionWhenConfirmed = (data:any) => boolean;

@Component({
    selector: 'modal-prompt',
    template: require('./modal-prompt.component.html'),
})

export class ModalPromptComponent implements OnInit {

    ngOnInit(): void {
    }

    constructor(private _promptService: ModalPromptService){
        _promptService.set(this);
    }

    //materialize-related
    modalActionsAsset = new EventEmitter<string | MaterializeAction>();
    params = [];
    modelParamsAsset = [
        {
            dismissible: true,
            complete: function () { console.log('Closed'); }
        }
    ];

    actionWhenConfirmed: ActionWhenConfirmed;
    data: any;

    get header(){
        return this.messageOptions.header;
    }

    get body(){
        return this.messageOptions.body;
    }

    messageOptions:PromptOptions = new PromptOptions();
    ret = new Subject<any>();

    modalOpen(callback: ActionWhenConfirmed, data: any, options: PromptOptions = {header: 'Please Confirm', body:'Are you sure you want to perform the requested action?'}): Subject<any> {
        this.messageOptions = options;
        this.actionWhenConfirmed = callback;
        this.data = data;
        this.modalActionsAsset.emit({ action: "modal", params: ['open'] });
        return this.ret;
    }

    modalClose(confirmed: boolean) {
        console.log('confirmed?: ' + confirmed);
        this.modalActionsAsset.emit({ action: "modal", params: ['close'] });
        if (confirmed){
            if (this.actionWhenConfirmed)
                this.actionWhenConfirmed(this.data);

            this.ret.next(this.data);
            
        }else{
            this.ret.next();
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/modal-prompt.component.ts